module.exports = __webpack_public_path__ + "media/Video 106.3393f47c.mp4";